/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchBetUserVote = {
    properties: {
        matchId: {
            type: 'number',
            isRequired: true,
        },
        bet: {
            type: 'MatchLocationEnum',
            isRequired: true,
        },
    },
} as const;
